import { useState, useEffect } from 'react';
import client from '../../api/client';
import { NAVY, AMBER, AMBER_DARK, BORDER_COLOR, bubbleStyle, fieldStyle } from '../../styles/tokens';

const GROUP_OPTIONS = [
  { key: 'project', label: 'Por Proyecto' },
  { key: 'user', label: 'Por Empleado' },
  { key: 'week', label: 'Por Semana' },
];

function fmtWeekLabel(dateStr) {
  const d = new Date(dateStr);
  const end = new Date(d);
  end.setDate(end.getDate() + 4);
  return `${d.toLocaleDateString('es-MX', { day: '2-digit', month: 'short' })} — ${end.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}`;
}

export default function TimesheetReportsPage() {
  const [data, setData] = useState([]);
  const [groupBy, setGroupBy] = useState('project');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    client.get('/api/timesheets/report', { params: { groupBy } })
      .then(r => setData(r.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [groupBy]);

  const totalHours = data.reduce((sum, d) => sum + parseFloat(d.total_hours), 0);

  return (
    <div className="page-pad" style={{ padding: '20px 24px', maxWidth: 800, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
        <h1 style={{ fontSize: 20, fontWeight: 700, color: NAVY, margin: 0 }}>Reportes de Horas</h1>
      </div>

      {/* Group by tabs */}
      <div className="filter-bar" style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {GROUP_OPTIONS.map(g => (
          <button
            key={g.key}
            onClick={() => setGroupBy(g.key)}
            style={{
              padding: '5px 14px', fontSize: 12, fontWeight: 600,
              borderRadius: 20, cursor: 'pointer',
              border: `1.5px solid ${groupBy === g.key ? AMBER : BORDER_COLOR}`,
              background: groupBy === g.key ? '#fef3c7' : '#fff',
              color: groupBy === g.key ? AMBER_DARK : '#64748b',
              fontFamily: 'Inter, sans-serif',
            }}
          >
            {g.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>Cargando...</div>
      ) : data.length === 0 ? (
        <div style={{ ...bubbleStyle, padding: 40, textAlign: 'center', color: '#94a3b8', fontSize: 14 }}>
          No hay datos aprobados para mostrar.
        </div>
      ) : (
        <div style={{ ...bubbleStyle, padding: 0, overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f8fafc' }}>
                <th style={{ textAlign: 'left', padding: '10px 14px', fontWeight: 600, color: NAVY, borderBottom: `1px solid ${BORDER_COLOR}` }}>
                  {groupBy === 'project' ? 'Proyecto' : groupBy === 'user' ? 'Empleado' : 'Semana'}
                </th>
                <th style={{ textAlign: 'right', padding: '10px 14px', fontWeight: 600, color: NAVY, borderBottom: `1px solid ${BORDER_COLOR}`, width: 120 }}>
                  Horas
                </th>
                <th style={{ textAlign: 'left', padding: '10px 14px', borderBottom: `1px solid ${BORDER_COLOR}`, width: '40%' }}>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, i) => {
                const hours = parseFloat(row.total_hours);
                const pct = totalHours > 0 ? (hours / totalHours) * 100 : 0;
                const label = groupBy === 'week' ? fmtWeekLabel(row.label) : (row.label || 'Sin asignar');
                return (
                  <tr key={i} style={{ borderBottom: `1px solid ${BORDER_COLOR}` }}>
                    <td style={{ padding: '10px 14px', fontWeight: 500, color: NAVY }}>
                      {label}
                    </td>
                    <td style={{ textAlign: 'right', padding: '10px 14px', fontWeight: 600, color: NAVY }}>
                      {hours.toFixed(1)}
                    </td>
                    <td style={{ padding: '10px 14px' }}>
                      <div style={{
                        height: 8, borderRadius: 4, background: '#f1f5f9',
                        overflow: 'hidden',
                      }}>
                        <div style={{
                          width: `${pct}%`, height: '100%',
                          background: AMBER, borderRadius: 4,
                          transition: 'width 0.3s',
                        }} />
                      </div>
                    </td>
                  </tr>
                );
              })}
              {/* Total row */}
              <tr style={{ background: '#f8fafc' }}>
                <td style={{ padding: '10px 14px', fontWeight: 700, color: NAVY }}>Total</td>
                <td style={{ textAlign: 'right', padding: '10px 14px', fontWeight: 800, color: AMBER_DARK }}>
                  {totalHours.toFixed(1)}
                </td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
